module.exports = __webpack_public_path__ + "img/customerCase.eb03923b.png";